import { IUser } from '@core/models';

export enum LocalStorageKeys {
  USER,
  TOKEN,
}

export const setUserLocalStorage = (value: IUser) => (
  localStorage.setItem(LocalStorageKeys.USER.toString(), JSON.stringify(value))
);
export const getUserLocalStorage = () => {
  const user = localStorage.getItem(LocalStorageKeys.USER.toString());
  return user ? JSON.parse(user) : null;
};
export const setTokenLocalStorage = (value: string) => (
  localStorage.setItem(LocalStorageKeys.TOKEN.toString(), value)
);
export const getTokenLocalStorage = () => (
  localStorage.getItem(LocalStorageKeys.TOKEN.toString())
);
export const clearLocalStorage = () => localStorage.clear();
